// src/components/ConsentedVercelAnalytics.tsx

"use client"

import { Analytics } from "@vercel/analytics/next"
import type { ReactNode } from "react"

/**
 * Vercel Web Analytics — cookieless first-party audience measurement.
 *
 * Intentionally **not** gated on {@link isAnalyticsAllowed}. The site's
 * first-party analytics posture
 * (`docs/analytics/first-party-analytics-posture.md`) is to collect as much
 * first-party measurement as the law allows. Vercel Web Analytics:
 *
 * - sets no cookies / no device storage (ePrivacy Art. 5(3) storage consent
 *   does not attach to the script itself)
 * - collects no PII / no cross-site identifier (CNIL-style audience-measurement
 *   exemption criteria; aligns with Speed Insights, which is also ungated)
 * - is first-party audience measurement for our own use (not sale/share — GPC
 *   does not apply)
 *
 * An explicit analytics opt-out still drops GA/custom events and first-party
 * storage writes; it does **not** suppress this cookieless counter. Gating it
 * previously was UX consistency only, not a legal requirement, and contradicted
 * the posture — reversed 2026-07.
 *
 * The component name is retained so existing layout imports stay stable.
 *
 * @returns {ReactNode} The ungated Vercel Analytics island.
 * @see docs/analytics/first-party-analytics-posture.md
 * @see https://vercel.com/docs/analytics/privacy-policy
 */
export default function ConsentedVercelAnalytics(): ReactNode {
  return <Analytics />
}
